import { render, staticRenderFns } from "./workPlatform.vue?vue&type=template&id=1d58d3e3&scoped=true&"
import script from "./workPlatform.vue?vue&type=script&lang=js&"
export * from "./workPlatform.vue?vue&type=script&lang=js&"
import style0 from "./workPlatform.vue?vue&type=style&index=0&id=1d58d3e3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d58d3e3",
  null
  
)

export default component.exports